import { Injectable } from '@angular/core';
import { AsyncSubject } from 'rxjs';
import { ModalController } from '@ionic/angular';
import { SignaturePadComponent } from './signature-pad.component';

@Injectable({
    providedIn: 'root',
})
export class SignaturePadService {

    constructor(
        private modalCtrl: ModalController
    ) { }

    public openModal(): AsyncSubject<SignatureDataCallbackBean> {

        let subject = new AsyncSubject<SignatureDataCallbackBean>();

        this.modalCtrl.create({
            component: SignaturePadComponent,
            breakpoints: [0, 1],
            initialBreakpoint: 1,
            cssClass: 'custom-signature-dialog',
            canDismiss: this.canDismiss,
        }).then(modal => {
            modal.present();
            modal.onWillDismiss().then(({ data }) => {
                subject.next(data);
                subject.complete();
            });
        });

        return subject;
    }

    private async canDismiss(data: SignatureDataCallbackBean) {
        if (!data) return false;
        if (data.role == SignatureCallbackRole.CONFIRM) return true;
        if (data.role == SignatureCallbackRole.CANCEL) return true;
        return false;
    }

}

export enum SignatureCallbackRole {
    CONFIRM = 'CONFIRM',
    CANCEL = 'CANCEL',
}

export interface SignatureData {
    latitude: number | null;
    longitude: number | null;
    base64Signature: string | null;
}

export interface SignatureDataCallbackBean extends SignatureData {
    role: SignatureCallbackRole;
}
